// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__10cWq","header":"PatientBlock_header__3wBu9","label":"PatientBlock_label__1LW5K","option":"PatientBlock_option__BlRv2"};